import { render, staticRenderFns } from "./DeleteShipper.vue?vue&type=template&id=9c04336c"
import script from "./DeleteShipper.vue?vue&type=script&lang=js"
export * from "./DeleteShipper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports